import { s } from "../../../utilities/common"

export const HeadphonesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={s("144")}
    height={s("144")}
    viewBox="0 0 144 144"
    fill="none"
  >
    <path
      d="M22.0184 143.999C18.6548 144.063 15.4027 142.792 12.9738 140.465C10.5449 138.137 9.13708 134.942 9.05835 131.579V85.9188C9.28171 82.6417 10.7411 79.5717 13.1413 77.3295C15.5416 75.0872 18.7037 73.84 21.9883 73.84C25.273 73.84 28.4351 75.0872 30.8354 77.3295C33.2356 79.5717 34.695 82.6417 34.9183 85.9188V131.579C34.8871 133.241 34.5286 134.882 33.8634 136.406C33.1981 137.93 32.2392 139.308 31.0413 140.461C29.8433 141.614 28.4299 142.521 26.8817 143.128C25.3336 143.734 23.681 144.031 22.0184 143.999ZM22.0184 82.4987C21.041 82.4325 20.0768 82.7545 19.3354 83.3948C18.594 84.0352 18.1351 84.9421 18.0583 85.9188V131.579C18.1499 132.549 18.613 133.447 19.351 134.085C20.0889 134.722 21.0446 135.049 22.0184 134.999C22.9858 135.049 23.9345 134.719 24.6628 134.081C25.3911 133.442 25.8415 132.544 25.9183 131.579V85.9188C25.8955 85.4326 25.7758 84.9558 25.5665 84.5164C25.3572 84.077 25.0623 83.6837 24.6991 83.3597C24.336 83.0356 23.9119 82.7873 23.4515 82.6292C22.9912 82.471 22.504 82.4063 22.0184 82.4388V82.4987Z"
      fill="white"
    />
    <path
      d="M122.038 143.999C118.674 144.063 115.422 142.792 112.993 140.465C110.564 138.137 109.157 134.942 109.078 131.579V85.9188C109.301 82.6417 110.761 79.5717 113.161 77.3295C115.561 75.0872 118.723 73.84 122.008 73.84C125.293 73.84 128.455 75.0872 130.855 77.3295C133.255 79.5717 134.714 82.6417 134.938 85.9188V131.579C134.907 133.241 134.548 134.882 133.883 136.406C133.218 137.93 132.259 139.308 131.061 140.461C129.863 141.614 128.449 142.521 126.901 143.128C125.353 143.734 123.701 144.031 122.038 143.999ZM122.038 82.4987C121.064 82.448 120.108 82.7755 119.371 83.4128C118.633 84.0501 118.169 84.948 118.078 85.9188V131.579C118.169 132.549 118.633 133.447 119.371 134.085C120.108 134.722 121.064 135.049 122.038 134.999C123.005 135.049 123.954 134.719 124.682 134.081C125.411 133.442 125.861 132.544 125.938 131.579V85.9188C125.861 84.9531 125.411 84.0556 124.682 83.4169C123.954 82.7782 123.005 82.4488 122.038 82.4987Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M9 109.74H0V68.34C0 30.66 32.28 0 72 0V9C37.26 9 9 35.64 9 68.34V109.74Z"
      fill="white"
    />
    <path
      opacity="0.8"
      d="M144 109.74H135V68.34C135 35.64 106.74 9 72 9V0C111.72 0 144 30.66 144 68.34V109.74Z"
      fill="white"
    />
  </svg>
)
